(function () {
  document.querySelectorAll('[data-footer-lola]').forEach(function (section) {
    initAccordions(section);
    initDesktopMenuRedistribution(section);
    initLocaleCombos(section);
  });

  // Desktop-only left-menu redistribution ("Left menu layout" in the
  // schema). Deliberately implemented in JS, not Liquid — the setting
  // should have ZERO effect on mobile, and Liquid has no concept of
  // viewport width at render time, so the only reliable way to keep
  // mobile's DOM completely untouched is to leave the server-rendered
  // markup exactly as it always was, and physically move <li> elements
  // between the two <ul>s only once matchMedia confirms we're at
  // desktop width — reverting them back to their original left-menu
  // position if the window is ever resized back down to mobile.
  function initDesktopMenuRedistribution(section) {
    var top = section.querySelector('[data-footer-lola-top]');
    if (!top) return;

    var layout = top.getAttribute('data-left-menu-layout') || 'left';
    var rightMenuEmpty = top.getAttribute('data-right-menu-empty') === 'true';

    // Nothing to redistribute: either the merchant left it on "Left"
    // (default), or the right menu already has its own content (per
    // the confirmed rule, redistribution only kicks in when the right
    // menu is empty).
    if (layout === 'left' || !rightMenuEmpty) return;

    var leftNav = section.querySelector('.footer-lola__nav--left');
    if (!leftNav) return;
    var leftList = leftNav.querySelector('[data-footer-lola-menu-list="left"]');
    if (!leftList) return;

    var splitAt = parseInt(top.getAttribute('data-left-menu-split-at'), 10) || 2;
    var breakpoint = window.matchMedia('(min-width: 750px)');
    var injectedRightNav = null;
    var movedItems = [];

    function applyDesktop() {
      if (injectedRightNav) return; // already applied, nothing to do

      var items = Array.prototype.slice.call(leftList.children);
      var toMove = layout === 'right' ? items : items.slice(splitAt);
      if (!toMove.length) return;

      injectedRightNav = document.createElement('div');
      injectedRightNav.className = 'footer-lola__nav footer-lola__nav--right';
      var ul = document.createElement('ul');
      ul.className = 'footer-lola__menu-list';
      injectedRightNav.appendChild(ul);

      toMove.forEach(function (li) {
        ul.appendChild(li); // also removes it from leftList
        movedItems.push(li);
      });

      top.appendChild(injectedRightNav);

      // "Right" mode moves every link out — hide the now-empty left
      // accordion shell entirely rather than leaving a blank one.
      if (layout === 'right') {
        leftNav.style.display = 'none';
      }
    }

    function revertToMobile() {
      if (!injectedRightNav) return;

      // Restored in their original order, back into the exact same
      // list the server rendered — mobile ends up pixel-identical to
      // how it was before this feature existed.
      movedItems.forEach(function (li) {
        leftList.appendChild(li);
      });
      movedItems = [];
      injectedRightNav.remove();
      injectedRightNav = null;
      leftNav.style.display = '';
    }

    function sync() {
      if (breakpoint.matches) {
        applyDesktop();
      } else {
        revertToMobile();
      }
    }

    breakpoint.addEventListener('change', sync);
    sync();
  }

  // Mobile-only accordion behavior for the left/right footer menus.
  // Exclusive: opening one automatically closes the other, like a
  // classic accordion. On desktop the toggle button is display:none via
  // CSS (see footer-lola.css), so it's never clickable there — this
  // script only ever matters on mobile, no viewport check needed.
  function initAccordions(section) {
    var accordions = Array.prototype.slice.call(
      section.querySelectorAll('[data-footer-lola-accordion]')
    );
    if (!accordions.length) return;

    function closeAccordion(accordion) {
      var toggle = accordion.querySelector('[data-footer-lola-accordion-toggle]');
      accordion.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    function openAccordion(accordion) {
      var toggle = accordion.querySelector('[data-footer-lola-accordion-toggle]');
      accordion.classList.add('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }

    accordions.forEach(function (accordion) {
      var toggle = accordion.querySelector('[data-footer-lola-accordion-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var isOpen = accordion.classList.contains('is-open');

        // Close every accordion first (including this one) so opening
        // it fresh below always results in exactly zero or one open,
        // never two at once.
        accordions.forEach(closeAccordion);

        if (!isOpen) {
          openAccordion(accordion);
        }
      });
    });
  }

  // Selector de país/región + idioma: componente propio (botón + lista),
  // reemplaza al <select> nativo porque la lista desplegable nativa no
  // se puede estilizar (fondo, esquinas redondeadas, separadores). Cada
  // opción es un <button type="submit"> con su propio name/value — al
  // hacer clic se envía SOLO ese campo, de forma nativa, sin necesitar
  // ningún truco para evitar mandar el otro campo sin querer (a
  // diferencia del <select> compartido de antes, que si mandaba los dos
  // a la vez y causaba el bug de "siempre vuelve a Alemania"). Mismas
  // convenciones de apertura/cierre que el resto del proyecto
  // (aria-expanded, Escape, clic afuera).
  function initLocaleCombos(section) {
    var combos = Array.prototype.slice.call(section.querySelectorAll('[data-footer-lola-combo]'));
    if (!combos.length) return;

    combos.forEach(function (combo) {
      var toggle = combo.querySelector('[data-footer-lola-combo-toggle]');
      var list = combo.querySelector('[data-footer-lola-combo-list]');
      if (!toggle || !list) return;

      function close() {
        list.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', onKeydown);
        document.removeEventListener('click', onDocumentClick);
      }

      function open() {
        // Solo un combo abierto a la vez — cierra cualquier otro que ya
        // estuviera abierto en esta misma franja.
        combos.forEach(function (other) {
          if (other === combo) return;
          var otherToggle = other.querySelector('[data-footer-lola-combo-toggle]');
          var otherList = other.querySelector('[data-footer-lola-combo-list]');
          if (otherList) otherList.hidden = true;
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        });

        list.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        document.addEventListener('keydown', onKeydown);
        document.addEventListener('click', onDocumentClick);
      }

      function onKeydown(event) {
        if (event.key === 'Escape') {
          close();
          toggle.focus();
        }
      }

      function onDocumentClick(event) {
        if (!combo.contains(event.target)) close();
      }

      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          close();
        } else {
          open();
        }
      });
    });
  }
})();